import 'shared/global';
import 'components/subnav';
import portraitCarousel from 'components/portraitCarousel';

try {
    portraitCarousel({
        parentContainer: $('#js-cast')
    });
} catch (e) {
    console.error('Cast failed to load', e);
}

import textSizesSwitcher from 'shows/textSizesSwitcher';

textSizesSwitcher({
    target: '#js-character-copy'
});
